"use client";

import { useEffect } from "react";

export default function VConsole() {
  useEffect(() => {
    let active = true;
    let vConsole: { destroy?: () => void } | undefined;

    void import("vconsole")
      .then(({ default: VConsoleInstance }) => {
        if (!active) return;
        vConsole = new VConsoleInstance({ theme: "light" });
        console.info("[vConsole] enabled");
      })
      .catch((error) => console.error("[vConsole] failed to load", error));

    return () => {
      active = false;
      vConsole?.destroy?.();
    };
  }, []);

  return null;
}
